import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../global-components/src';

interface AuthenticatedRouteProps {
    children: React.ReactNode; // Recebe os filhos que serão protegidos
}

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />; // Redireciona para login se não autenticado
    }
    return <>{children}</>; // Retorna os filhos se autenticado
};

export default AuthenticatedRoute;
